<template>
  <CRow>
    <CCol>
        <CCard>
          <CCardHeader>
            {{ $t('cert.MyCertificate') }}
          </CCardHeader>
          <CCardBody>
            <cert/>
          </CCardBody>
      </CCard>
    </CCol>
  </CRow>
</template>


<script>
import Cert from './Cert.vue'

export default {
  name: "CertIndex",
  components: {
    Cert,
  }
}
</script>
